const pos = (obj) => Number(obj);
export default pos;
